import type { IconProps } from "./types";

export function TriangleDown({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.30111 0.4453C4.69694 -0.148433 5.56939 -0.148433 5.96521 0.4453L10.0967 6.64252C10.5397 7.30708 10.0633 8.19722 9.26465 8.19722H1.00168C0.202986 8.19722 -0.273405 7.30708 0.169631 6.64252L4.30111 0.4453Z"
        fill={currentColor}
        transform="translate(6.87 7.8) scale(1 -1) translate(0 -8.2)"
      />
    </svg>
  );
}
